var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "content" } }, [
    _c("div", { staticClass: "container content-container" }, [
      _c("div", { attrs: { id: "not-found-page" } }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-7" }, [
            _c("h1", [_vm._v(_vm._s(_vm.translate.home.page404_1))]),
            _vm._v(" "),
            _c("h2", [
              _vm._v(_vm._s(_vm.translate.home.page404_2)),
              _c("br"),
              _vm._v("Err: 404")
            ]),
            _vm._v(" "),
            _c("h4", [_vm._v(_vm._s(_vm.translate.home.page404_3))]),
            _vm._v(" "),
            _c("h5", [_vm._v(_vm._s(_vm.translate.home.page404_4))]),
            _vm._v(" "),
            _c(
              "ul",
              _vm._l(_vm.lodash.get(_vm.regionData, "404Locations"), function(
                location
              ) {
                return _c("li", [
                  _c(
                    "a",
                    { attrs: { href: _vm.regionRelativeUrl(location.path) } },
                    [_vm._v(_vm._s(location.name))]
                  )
                ])
              }),
              0
            )
          ]),
          _vm._v(" "),
          _vm._m(0)
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-5 d-flex justify-content-center" }, [
      _c("img", {
        staticClass: "not-found-image",
        attrs: { src: "/images/404.jpg", alt: "" }
      })
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3c55dfe6", { render: render, staticRenderFns: staticRenderFns })
  }
}